import { APP_URL } from 'core/config/constants';
import { getProductDetails } from '../wl_product/api';
import { WLProductT } from '../wl_product/model';

import { setProductData } from './repository';

export const loadCurrentProductDetails = (): Promise<WLProductT> => {
  return getProductDetails({
    domain: new URL(APP_URL).host,
  }).then(({ data }) => {
    setProductData(data);
    return data;
  });
};
